export default "__VITE_ASSET__jiZV47jy__"